module.exports = __webpack_public_path__ + "static/success-3826b450f448d4db5cdb7c511e4e51a9.svg";